<div class="fm-search-light-category-results-menu" *ngIf="shouldShowMenu()">
  <fm-menu-panel (menuOptionKeydown)="onMenuOptionKeydown($event)">
    <div class="fm-search-light-category-results-menu__list">
      <fm-menu-option *ngFor="let categoryResult of category.items" [class.fm-search-light-category-results-menu--disabled]="!categoryResult.lat || !categoryResult.lng" (menuOptionSelected)="onMenuOptionSelected(categoryResult)">
        {{ categoryResult.text }}
      </fm-menu-option>
    </div>
  </fm-menu-panel>
</div>
